"use client";
import { socialLinks } from "@/data/blogs";
import { footerLinks } from "@/data/menu";
import Image from "next/image";
import Link from "next/link";
import "photoswipe/dist/photoswipe.css";
import { useEffect, useState } from "react";

export default function Footer1() {
  const [contact, setContact] = useState([]);
  const [about, setAbout] = useState({});
  const [socials, setSocials] = useState({});

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const [contactRes, webContentRes] = await Promise.all([
          fetch("/api/contactus"),
          fetch("/api/web-content"),
        ]);

        if (!contactRes.ok || !webContentRes.ok) {
          throw new Error("API failed");
        }

        const contactData = await contactRes.json();
        const webContentData = await webContentRes.json();

        setContact(contactData);
        setAbout(webContentData.about || {});
        setSocials(webContentData.socialLinks || {});
      } catch (error) {
        console.log(error);
      }
    };

    fetchFooterData();
  }, []);

  const contactData = contact[0];
  // const aboutData = about;
  const shortContent = about?.content
    ? about.content.replace(/<[^>]+>/g, "").slice(0, 231)
    : "Welcome to Arena Water Park";

  return (
    <footer className="footer-section">
      <div className="container">

        {/* Top Title */}
        <div className="row align-items-center mb-4">
          <div className="col-lg-8">
            <h2 className="footer-title">Experience the thrill!</h2>
          </div>

          <div className="col-lg-4 text-lg-end text-center mt-3 mt-lg-0">
            <button className="btn footer-btn" onClick={() => window.location.href = "/contact"}>Get In Touch</button>
          </div>
        </div>

        <hr className="footer-divider" />

        {/* Footer Content */}
        <div className="row mt-5">

          {/* Column 1 */}
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="footer-logo mb-3">
              <Image
                src="/assets/img/logo.png"
                alt="logo"
                width={120}
                height={80}
              />
            </div>

            <p className="footer-desc">
              {shortContent}
              {about?.content ? "" : ""}
            </p>
          </div>

          {/* Column 2 */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-heading">Address Information</h5>

            <div className="footer-address">
              <span className="icon-circle">
                <i className="fa-sharp fa-solid fa-location-dot" />
              </span>

              <p>
                {contactData?.parklocation}
              </p>
            </div>

            <div className="footer-social">
              {socials?.facebook && (
                <a href={socials.facebook} target="_blank">
                  <i className="fab fa-facebook-f" />
                </a>
              )}
              {socials?.twitter && (
                <a href={socials.twitter} target="_blank">
                  <i className="fab fa-twitter" />
                </a>
              )}
              {socials?.youtube && (
                <a href={socials.youtube} target="_blank">
                  <i className="fab fa-youtube" />
                </a>
              )}
              {socials?.linkedin && (
                <a href={socials.linkedin} target="_blank">
                  <i className="fab fa-linkedin-in" />
                </a>
              )}
              {socials?.instagram && (
                <a href={socials.instagram} target="_blank">
                  <i className="fab fa-instagram" />
                </a>
              )}
            </div>
          </div>

          {/* Column 3 */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-heading">Important Links</h5>

            <ul className="footer-links">
              <li><Link href="/login">SignIn</Link></li>
              <li><Link href="/register">Create An Account</Link></li>
              <li><Link href="/gallery">Gallery</Link></li>
              <li><Link href="/privacy-policy">Privacy Policy</Link></li>
              <li><Link href="/cookie-policy">Cookie Policy</Link></li>
              <li><Link href="/terms-conditions">Terms Of Service</Link></li>
              <li><Link href="/park-rules">Park Rules Regualtions & Legal Conditions</Link></li>
              <li><Link href="/ride-safety">Ride Safety Coverage</Link></li>
              <li><Link href="/dress-code">Dress Code Policy</Link></li>
              <li><Link href="/reschedule-policy">Reschedule Policy</Link></li>
              {/* <li><Link href="/ride-safety-coverage">Ride Safety Coverage</Link></li> */}
            </ul>
          </div>

          {/* Column 4 */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-heading">Contact Information</h5>

            <div className="contact-item">
              {/* <span className="icon-circle">
                <i className="fa-solid fa-phone-volume" />
              </span> */}

              {/* <div>
                <h6>Phone Number</h6>
                <p><a href={`tel:${contactData?.mobile}`}>{contactData?.mobile}</a></p>
              </div> */}
            </div>

            <div className="contact-item">
              <span className="icon-circle">
                <i className="fa-solid fa-envelope" />
              </span>

              <div>
                <h6>Email Address</h6>
                <p>
                  <a href={`mailto:${contactData?.email}`}>
                    {contactData?.email}
                  </a>
                </p>
              </div>
            </div>

            <div className="mt-4 ps-5">
              <p className="mb-0" style={{ fontSize: "15px", color: "#ddd" }}>
                For more Contacts Visit <br />
                <Link
                  href="/contact"
                  style={{
                    color: "#f95500",

                    fontWeight: "bold",
                  }}
                >
                  Contact Us
                </Link>
              </p>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <hr className="footer-divider" />

        <div className="row footer-bottom align-items-center">

          <div className="col-lg-4 text-center text-lg-start mb-2 mb-lg-0 ">
            Copyright © 2026 All Rights Reserved Designed and Developed by <Link href="https://thecolourmoon.com" target="_blank" style={{ color: "#ffffffff", fontWeight: "bold" }}>The Colour Moon</Link>
          </div>

          <div className="col-lg-8 text-center text-lg-end">
            <ul className="footer-menu">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <Link href={link.href}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </footer>
  );
}
